<template>
  <div class="km__modules__contact km__popup">
    <button class="km__button--back" type="button" name="back" @click="closeContact" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="closeContact" aria-label="close"></button>
    <h2 class="km__popup--heading">{{ $t("konf_kontakt") }}</h2>
    <div class="km__popup--content">
      <div v-for="abschnitt in contactdata" :key="abschnitt" class="adressblock">
        <div v-for="paragraph in abschnitt" :key="paragraph" class="adressabschnitt">
          <span class="adressline" v-for="line in paragraph" :key="line" v-html="line"></span>
        </div>
      </div>
      <div>{{ $t("km_pre_linkToContactForm") }} <a href="#"
                                                   @click="openContactForm">{{ $t("konf_kontaktformular_fuer_button") }}
        {{ $t("km_post_linkToContactForm") }}</a></div>
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard" @click="closeContact">{{ $t("konf_Close") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>


import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory} from "@km/animations/animationFactory";
import {computed, ComputedRef, onBeforeUnmount, onMounted} from "vue";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";


const store = useStore();
const contactdata = computed(() => store.getters["ModelStore/getContactData"]) as ComputedRef<string[][][]>;

function closeContact() {
  store.commit("SET_OVERLAY_CLOSED", 'contact');
}


const openContactForm = () => {
  store.commit("SET_OVERLAY_CLOSED", OverlayNames.contact);
  store.commit("SET_OVERLAY_OPEN", OverlayNames.contactform)
};
</script>

<style lang="scss" scoped>
.km__modules__contact {
  z-index: 999;
  overflow-y: scroll;
}

.adressline {
  display: block;
}

.adressabschnitt {
  margin-bottom: 2em;
}

:deep(strong) {
  font-weight: bold;
}

:deep(small) {
  font-size: smaller;
}

</style>
